import injectSheet from "react-jss";

export default styles => Component => {
  const StyledComponent = injectSheet(styles)(Component);
  StyledComponent.propTypes = Component.propTypes;
  StyledComponent.defaultProps = Component.defaultProps;
  StyledComponent.displayName = Component.name;
  return StyledComponent;
};
